export default "__VITE_ASSET__11d43f67__"